module.exports = __webpack_public_path__ + "img/send-icon-send.7d1b4b0c.svg";